import api from '../api';

/**
 * Reset filters (table or global) for a given path
 * @param {string} path - The path of the page
 * @param {'tableFilters' | 'globalFilters'} type - The type of filters to reset
 * @returns {Promise<void>}
 */
export const postResetFilters = async (path, type) => {
  const response = await api.post(
    `/reset-filters?path=${path}`,
    { type },
  );
  return response.data;
};
